import { useEffect } from 'react';
import { SUPPORTED_LANGS } from '@/i18n';
import { useUiStore } from '@/store';

/**
 * LT/EN switch. In the monolith this fired a full re-render of every open
 * view by hand (applyTranslations() ended with a dozen `if (view is active)
 * render…` calls, and one bug there — a stray querySelectorAll('.lang-btn')
 * — made an unrelated export control call setLanguage(undefined)). Here the
 * language is one Zustand slice: components reading useT() re-render
 * themselves and nothing else has to know.
 */
export function LanguageToggle() {
  const lang = useUiStore((s) => s.lang);
  const setLang = useUiStore((s) => s.setLang);

  // Keep <html lang> in step for screen readers and for the browser's own
  // hyphenation/spellcheck behavior.
  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <div className="flex items-center gap-0.5 rounded-full border border-line bg-white/3 p-[3px]">
      {SUPPORTED_LANGS.map((code) => (
        <button
          key={code}
          type="button"
          onClick={() => setLang(code)}
          aria-pressed={lang === code}
          className={`rounded-full px-2.5 py-1 text-[10.5px] font-bold tracking-[0.03em] ${
            lang === code ? 'bg-accent/15 text-accent' : 'text-dim hover:text-ink'
          }`}
        >
          {code.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
